/*
 * @Author: flyer
 * @Date: 2021-04-09 10:42:53
 * @LastEditTime: 2021-12-30 16:59:19
 * @LastEditors: jieyang
 * @Description: 用户管理接口配置
 */
export default {
  ServiceValidate: {
    url: "/opc-operation-api/login/v1/serviceValidate",
    method: "POST"
  },
  getWakeUpFlag: {
    url: "/szjy-science-user/clientTool/v1/getWakeUpFlag",
    method: "POST"
  }

};
